<template>
    <div>
        <router-link :to="to" class="w-full text-left py-3 flex items-center">
            <span class="text-responsive-sidebar-link hover:text-responsive-sidebar-link-hover text-xl font-thin"><slot></slot></span>
        </router-link>
    </div>
</template>

<script>
    export default {
        props: {
            icon: {
                type: String,
                default: '',
            },
            to: {
                type: Object,
                default() {
                    return {};
                }
            },
        }
    }
</script>
